module.exports = __webpack_public_path__ + "img/arrow-playlist-options.0f170333.svg";